// src/layouts/ClientLayout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import TaskToolbar from '../pages/client/TaskToolbar';
import AddTaskForm from '../pages/client/AddTaskForm';
import api from '../api';







const ClientLayout = () => {
  const navigate = useNavigate();

  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  // Actions
  const handleShowForm = () => setShowForm(true);
  const handleSearch = value => setSearchTerm(value);
  const handleDateStart = value => setDateStart(value);
  const handleDateEnd = value => setDateEnd(value);
  const handleModuleChange = module => navigate(`/client/${module}`);
const handleLogout = async () => {
  try {
    await api.post('/logout'); // Appel vers Laravel
    localStorage.clear();      // Nettoyer localStorage
    navigate('/');             // Rediriger vers login
  } catch (error) {
    console.error('Erreur logout :', error);
    alert('Impossible de se déconnecter.');
  }
};

  return (
    <div className="h-screen bg-gray-50 overflow-hidden">
      {/* Top Navigation Bar */}
      <div className="fixed top-0 left-0 right-0 z-30">
        <TaskToolbar
          onShowForm={handleShowForm}
          onSearch={handleSearch}
          onModuleChange={handleModuleChange}
          onDateStartChange={handleDateStart}
          onDateEndChange={handleDateEnd}
          onLogout={handleLogout}
        />
      </div>

      {/* Layout Container */}
      <div className="flex pt-16 h-full">


        {/* Main Content Area */}
        <main className="flex-1 bg-gray-50 overflow-hidden">
          {/* Add Task Form Modal */}
          {showForm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
              <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                <AddTaskForm
                  onClose={() => setShowForm(false)}
                  onAddTask={(newTask) => {/* implement as needed */}}
                />
              </div>
            </div>
          )}

          {/* Content Outlet */}
          <div className="h-full overflow-auto">
            <Outlet context={{ searchTerm, dateStart, dateEnd }} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default ClientLayout;